import { createApp } from 'vue'

import App from './App.vue'
import router from "./router";
import pinia from '@/state/pinia'
import VueApexCharts from "vue3-apexcharts";
import vClickOutside from "click-outside-vue3";
import { registerScrollSpy } from 'vue3-scroll-spy';

import { vMaska } from "maska"
import i18n from "./utils/i18n"
import { initPocketBaseUtils } from './utils/pocketbaseUtils'
import { initPredictionsApiUtils } from './utils/predictionsApiUtils';

import BootstrapVueNext from 'bootstrap-vue-next'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue-next/dist/bootstrap-vue-next.css'
import "@/assets/scss/app.scss";
import "@vueform/multiselect/themes/default.css"

// Initialise utility classes

const pocketBaseConfig = {
  baseUrl: process.env.VUE_APP_POCKETBASE_API_URL,
};

const predictionsApiConfig = {
  baseUrl: process.env.VUE_APP_PREDICTIONS_API_URL,
}

initPocketBaseUtils(...Object.values(pocketBaseConfig));
initPredictionsApiUtils(predictionsApiConfig);

import 'sweetalert2/dist/sweetalert2.min.css';
import '@vueform/slider/themes/default.css';

createApp(App)
  .use(pinia)
  .use(router)
  .use(require('vue-chartist'))
  .use(BootstrapVueNext)
  .use(VueApexCharts)
  .use(vClickOutside)
  .use(i18n)
  .use(registerScrollSpy)
  .directive("maska", vMaska)
  .mount('#app')
